import { render, staticRenderFns } from "./SupplierGoodsReceived.vue?vue&type=template&id=028eb8c8&scoped=true"
import script from "./SupplierGoodsReceived.vue?vue&type=script&lang=js"
export * from "./SupplierGoodsReceived.vue?vue&type=script&lang=js"
import style0 from "./SupplierGoodsReceived.vue?vue&type=style&index=0&id=028eb8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028eb8c8",
  null
  
)

export default component.exports